/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Components, Theme } from "@mui/material/styles";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import { ReportOutlined } from "@mui/icons-material";

export const muiAlertStyle = (): Components<Theme>["MuiAlert"] => ({
  defaultProps: {
    iconMapping: {
      warning: <ErrorOutlineOutlinedIcon />,
      error: <ReportOutlined />,
    },
  },
  styleOverrides: {
    root: {
      borderLeft: "0.1875rem",
      borderLeftStyle: "solid",
      borderRadius: "0.25rem",
      variants: [
        {
          props: { severity: "error" },
          style: ({ theme }) => ({
            color: theme.palette.error.main,
            borderLeftColor: theme.palette.error.main,
            backgroundColor: theme.palette.error.light,
          }),
        },
        {
          props: { severity: "warning" },
          style: ({ theme }) => ({
            color: theme.palette.warning.main,
            borderLeftColor: theme.palette.warning.main,
            backgroundColor: theme.palette.warning.light,
          }),
        },
        {
          props: { severity: "success" },
          style: ({ theme }) => ({
            color: theme.palette.success.main,
            borderLeftColor: theme.palette.success.main,
            backgroundColor: theme.palette.success.light,
          }),
        },
      ],
    },
    icon: {
      marginTop: "0.125rem",
    },
    message: {
      display: "flex",
      flexDirection: "column",
      flexGrow: 1,
      rowGap: "1rem",
    },
  },
});
